/* ND Experience - site-wide premium interactions */
(function () {
  "use strict";

  if (!document.body.classList.contains("nd-design")) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Page load state (curtain removed per client request).
     Keep the loading/ready classes so subpage hero reveals still resolve. */
  const finishLoad = () => {
    document.documentElement.classList.remove("nd-loading");
    document.documentElement.classList.add("nd-ready");
  };

  document.documentElement.classList.add("nd-loading");
  if (document.readyState === "complete") finishLoad();
  else window.addEventListener("load", finishLoad, { once: true });
  setTimeout(finishLoad, reduced ? 0 : 200);

  /* Scroll progress */
  const bar = document.createElement("div");
  bar.className = "nd-scroll-progress";
  bar.setAttribute("aria-hidden", "true");
  document.body.appendChild(bar);

  const onScroll = () => {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = h > 0 ? `${(window.scrollY / h) * 100}%` : "0%";
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* Staggered reveals */
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        if (el.matches("[data-reveal-stagger]")) {
          el.querySelectorAll(".reveal, [data-reveal-child]").forEach((child, i) => {
            child.style.setProperty("--stagger", i);
            child.classList.add("in");
          });
          el.classList.add("is-in");
        } else {
          el.classList.add("in");
        }
        io.unobserve(el);
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
  );

  document.querySelectorAll(".reveal, .reveal-scale, .reveal-left, .reveal-blur, [data-reveal-stagger]").forEach((el) =>
    io.observe(el)
  );

  /* Trust strip */
  document.querySelectorAll(".nd-trust-animate").forEach((strip) => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          strip.classList.add("is-in");
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(strip);
  });

  /* Count-up */
  const parseCount = (raw) => {
    const s = String(raw).trim();
    const hasPlus = s.includes("+");
    const cleaned = s.replace(/\+/g, "");
    const m = cleaned.match(/^([\d.,]+)\s*([MKmk])?$/);
    if (!m) return null;
    let n = parseFloat(m[1].replace(/,/g, ""));
    const unit = (m[2] || "").toUpperCase();
    if (unit === "M") n *= 1e6;
    if (unit === "K") n *= 1e3;
    return { n, unit, hasPlus, raw: s };
  };

  const formatCount = (val, info) => {
    if (info.unit === "M") {
      const m = val / 1e6;
      return `${m >= 10 ? Math.round(m) : m.toFixed(1).replace(/\.0$/, "")}M${info.hasPlus ? "+" : ""}`;
    }
    if (info.unit === "K") return `${Math.round(val / 1e3)}K${info.hasPlus ? "+" : ""}`;
    return `${Math.round(val)}${info.hasPlus ? "+" : ""}`;
  };

  document.querySelectorAll("[data-countup]").forEach((el) => {
    const info = parseCount(el.dataset.countup || el.textContent);
    if (!info) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting) return;
        obs.disconnect();
        if (reduced) return;
        const start = performance.now();
        const dur = 1400;
        const tick = (now) => {
          const p = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = formatCount(info.n * eased, info);
          if (p < 1) {
            requestAnimationFrame(tick);
          } else {
            el.classList.add("counted");
          }
        };
        requestAnimationFrame(tick);
      },
      { threshold: 0.5 }
    );
    obs.observe(el);
  });

  /* Compare row spotlight */
  document.querySelectorAll("table.compare tbody").forEach((tbody) => {
    tbody.querySelectorAll("tr").forEach((row) => {
      row.addEventListener("mouseenter", () => {
        tbody.querySelectorAll(".nd-row-active").forEach((r) => r.classList.remove("nd-row-active"));
        row.classList.add("nd-row-active");
      });
    });
    tbody.addEventListener("mouseleave", () => {
      tbody.querySelectorAll(".nd-row-active").forEach((r) => r.classList.remove("nd-row-active"));
    });
  });

  /* Subscribe plan toggle */
  document.querySelectorAll("[data-sub-toggle]").forEach((wrap) => {
    const select = (opt) => {
      wrap.querySelectorAll("[data-sub-opt]").forEach((o) => o.classList.remove("active"));
      opt.classList.add("active");
    };
    wrap.querySelectorAll("[data-sub-opt]").forEach((opt) => {
      opt.addEventListener("click", () => select(opt));
      opt.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          select(opt);
        }
      });
    });
  });

  /* Why card tilt */
  if (!reduced) {
    document.querySelectorAll(".why-card.nd-tilt").forEach((card) => {
      card.addEventListener("mousemove", (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(-4px)`;
      });
      card.addEventListener("mouseleave", () => {
        card.style.transform = "";
      });
    });
  }

  /* Subtle hero parallax */
  if (!reduced) {
    const heroMedia = document.querySelector(".nd-hero .hero-media");
    if (heroMedia) {
      window.addEventListener(
        "scroll",
        () => {
          const y = Math.min(window.scrollY * 0.08, 40);
          heroMedia.style.transform = `translateY(${y}px)`;
        },
        { passive: true }
      );
    }
  }

  /* Magnetic buttons */
  if (!reduced) {
    document.querySelectorAll(".btn.nd-magnetic").forEach((btn) => {
      btn.addEventListener("mousemove", (e) => {
        const r = btn.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        btn.style.transform = `translate(${x * 0.08}px, ${y * 0.12}px)`;
      });
      btn.addEventListener("mouseleave", () => {
        btn.style.transform = "";
      });
    });
  }

  /* Smooth anchor offset for sticky nav */
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      const id = a.getAttribute("href");
      if (!id || id === "#") return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: reduced ? "auto" : "smooth" });
    });
  });
})();
